import axios from '@/service/request';
import type { R, BuyerOperationTypeEnum } from './types';

/**
 * 发送验证码请求参数
 */
export interface MiniSendCaptchaRequest {
  /** 手机国内号码或邮箱 */
  account?: string;
  /** 手机国际区号（如 +86），邮箱注册/登录不传 */
  countryRegionCode?: string;
  /** 操作类型 */
  operationType?: BuyerOperationTypeEnum;
}

/**
 * 发送验证码(注册/登录)
 */
export const apiBuyerCaptchaSend = (data: MiniSendCaptchaRequest): Promise<R<boolean>> => {
  return axios.post('/buyer/captcha/send', data, {
    toastError: false
  });
};

